import { openDB } from 'idb';

const dbPromise = openDB('image-store', 1, {
  upgrade(db) {
    db.createObjectStore('images');
  },
});

export async function cacheImage(url) {
  const response = await fetch(url);
  const blob = await response.blob();
  const db = await dbPromise;
  await db.put('images', blob, url);
}

export async function getCachedImage(url) {
  const db = await dbPromise;
  const blob = await db.get('images', url);
  return blob ? URL.createObjectURL(blob) : null;
}